import addressApi from './axiosClient'

export default {
  loadMenu: courseId => {
    return addressApi.get(`courses/${courseId}`)
  },
}
